/* GLAMIEX theme scripts, part 2: cart drawer, sticky buy bar, filters, footer accordions. No dependencies. */
(function () {
  'use strict';
  document.documentElement.classList.add('glx-js');

  var T = window.GLXTheme || {};
  var root = T.root || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) { return T.formatMoney ? T.formatMoney(cents) : String(cents / 100); }

  /* ---------------- cart drawer ---------------- */
  var drawer = null;
  var busy = false;

  function bagSvg() {
    return '<svg class="glx-icon" viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 8h14l-1 12H6L5 8Z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>';
  }

  function lineHtml(item) {
    var img = item.image
      ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="' + esc(item.featured_image && item.featured_image.alt ? item.featured_image.alt : item.product_title) + '" width="72" height="72" loading="lazy">'
      : '<span class="glx-card__placeholder">' + bagSvg() + '</span>';
    var variant = item.product_has_only_default_variant || !item.variant_title ? '' : '<p class="glx-line__variant">' + esc(item.variant_title) + '</p>';
    var was = item.original_line_price > item.final_line_price ? '<s>' + money(item.original_line_price) + '</s>' : '';
    return (
      '<li class="glx-cd-line" data-key="' + esc(item.key) + '">' +
      '<a class="glx-cd-line__img" href="' + esc(item.url) + '">' + img + '</a>' +
      '<div class="glx-cd-line__body">' +
      '<a class="glx-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant +
      '<div class="glx-cd-line__row">' +
      '<div class="glx-qty glx-qty--sm">' +
      '<button type="button" class="glx-qty__btn" data-glx-cd-minus aria-label="Decrease quantity">&minus;</button>' +
      '<span class="glx-cd-qty" aria-live="polite">' + item.quantity + '</span>' +
      '<button type="button" class="glx-qty__btn" data-glx-cd-plus aria-label="Increase quantity">+</button>' +
      '</div>' +
      '<button type="button" class="glx-line__remove" data-glx-cd-remove aria-label="Remove ' + esc(item.product_title) + '">Remove</button>' +
      '</div></div>' +
      '<div class="glx-line__price">' + was + '<strong>' + money(item.final_line_price) + '</strong></div>' +
      '</li>'
    );
  }

  function paint(cart) {
    if (!drawer) return;
    var body = $('[data-glx-cart-body]', drawer);
    var foot = $('[data-glx-cart-foot]', drawer);
    var ship = $('[data-glx-cart-ship]', drawer);
    var count = $('[data-glx-drawer-count]', drawer);
    if (count) count.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (!cart.item_count) {
      body.innerHTML =
        '<div class="glx-noresult glx-noresult--drawer"><span class="glx-noresult__icon">' + bagSvg() + '</span>' +
        '<h2>Your cart is empty</h2><p>Add something you like and it will show up here.</p>' +
        '<a class="glx-btn glx-btn--primary" href="' + esc(root + 'collections/all') + '">Continue shopping</a></div>';
      foot.hidden = true;
      ship.hidden = true;
      return;
    }
    body.innerHTML = '<ul class="glx-cd-lines">' + cart.items.map(lineHtml).join('') + '</ul>';
    $('[data-glx-cart-total]', drawer).textContent = money(cart.total_price);
    foot.hidden = false;
    var threshold = Number(drawer.getAttribute('data-free-ship')) * 100;
    if (threshold > 0) {
      var left = threshold - cart.total_price;
      var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      ship.innerHTML =
        '<p>' + (left > 0 ? 'Add <strong>' + money(left) + '</strong> more for free shipping' : '<strong>You have free shipping.</strong>') + '</p>' +
        '<span class="glx-shipbar__track"><span style="width:' + pct + '%"></span></span>';
      ship.hidden = false;
    } else {
      ship.hidden = true;
    }
  }

  function loadCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function render() {
    drawer = $('[data-glx-drawer="cart"]');
    if (!drawer) return Promise.resolve();
    return loadCart().then(paint).catch(function () {
      var body = $('[data-glx-cart-body]', drawer);
      if (body) body.innerHTML = '<p class="glx-muted">We could not load your cart. <a href="' + esc(root + 'cart') + '">Open the cart page</a>.</p>';
    });
  }

  /* Open the drawer the moment the shopper taps Add to Cart, so the tap feels instant. */
  function opening() {
    drawer = $('[data-glx-drawer="cart"]');
    if (!drawer || !T.showDrawer) return false;
    if (drawer.hidden) T.showDrawer('cart', null, { skipRender: true });
    drawer.classList.add('is-busy');
    return true;
  }

  /* cart: the cart returned right after the add (one request), or nothing to load it here */
  function afterAdd(cart) {
    drawer = $('[data-glx-drawer="cart"]');
    if (!drawer) {
      if (T.toast) T.toast('Added to your cart', { href: root + 'cart', label: 'View cart' });
      return;
    }
    if (drawer.hidden && T.showDrawer) T.showDrawer('cart', null, { skipRender: true });
    drawer.classList.remove('is-busy');
    if (cart && cart.items) paint(cart);
    else {
      render();
      if (T.refreshCartCount) T.refreshCartCount();
    }
  }

  function addFailed() {
    drawer = $('[data-glx-drawer="cart"]');
    if (!drawer) return;
    drawer.classList.remove('is-busy');
    if (!drawer.hidden && T.hideDrawer) T.hideDrawer();
  }

  function changeLine(key, qty) {
    if (busy) return;
    busy = true;
    if (drawer) drawer.classList.add('is-busy');
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Could not update the cart.');
          return d;
        });
      })
      .then(function (cart) {
        paint(cart);
        if (T.refreshCartCount) T.refreshCartCount();
      })
      .catch(function (err) {
        if (T.toast) T.toast(err.message, { error: true });
        return render();
      })
      .then(function () {
        busy = false;
        if (drawer) drawer.classList.remove('is-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var line = e.target.closest('.glx-cd-line');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var q = parseInt($('.glx-cd-qty', line).textContent, 10) || 1;
    if (e.target.closest('[data-glx-cd-plus]')) changeLine(key, q + 1);
    else if (e.target.closest('[data-glx-cd-minus]')) changeLine(key, q - 1);
    else if (e.target.closest('[data-glx-cd-remove]')) changeLine(key, 0);
  });

  window.GLXCart = { render: render, afterAdd: afterAdd, opening: opening, addFailed: addFailed };

  /* ---------------- cart page ---------------- */
  function initCartPage() {
    var form = $('[data-glx-cart-form]');
    if (!form || form.getAttribute('data-glx-init')) return;
    form.setAttribute('data-glx-init', '1');
    var update = $('[data-glx-update]', form);
    if (update) update.classList.add('glx-hide-js');
    function submitUpdate() {
      if (form.requestSubmit && update) form.requestSubmit(update);
      else form.submit();
    }
    form.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-glx-line-minus]');
      var plus = e.target.closest('[data-glx-line-plus]');
      if (!minus && !plus) return;
      var input = $('[data-glx-line-qty]', (minus || plus).parentNode);
      var n = parseInt(input.value, 10) || 0;
      input.value = Math.max(0, n + (plus ? 1 : -1));
      submitUpdate();
    });
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-glx-line-qty]')) submitUpdate();
    });
  }

  /* ---------------- sticky buy bar (product page) ---------------- */
  function initSticky() {
    var bar = $('[data-glx-sticky]');
    var buy = $('[data-glx-product] .glx-buy');
    if (!bar || !buy || bar.getAttribute('data-glx-init')) return;
    bar.setAttribute('data-glx-init', '1');
    function set(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('glx-sticky-on', on);
      $$('button', bar).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
    }
    var ticking = false;
    function check() {
      ticking = false;
      set(buy.getBoundingClientRect().bottom < 0);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
  }

  /* ---------------- filters and sort ---------------- */
  function initFilters() {
    $$('[data-glx-sort]').forEach(function (sel) {
      if (sel.getAttribute('data-glx-init')) return;
      sel.setAttribute('data-glx-init', '1');
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
    $$('[data-glx-filter-form]').forEach(function (form) {
      if (form.getAttribute('data-glx-init')) return;
      form.setAttribute('data-glx-init', '1');
      var timer;
      var inDrawer = !!form.closest('.glx-filterdrawer');
      form.addEventListener('change', function () {
        if (inDrawer) return; /* phones: apply with the button */
        clearTimeout(timer);
        timer = setTimeout(function () { form.submit(); }, 350);
      });
    });
  }

  /* ---------------- footer accordions (phones) ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-glx-acc-toggle]');
    if (!t) return;
    var col = t.closest('[data-glx-acc-col]');
    var open = !col.classList.contains('is-open');
    col.classList.toggle('is-open', open);
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------------- misc ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-glx-scroll-buy]');
    if (!b) return;
    e.preventDefault();
    var target = $('[data-glx-product]') || document.body;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  function init(scope) {
    initCartPage();
    initSticky();
    initFilters();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();